<template>
  <v-content class="pa-12">
    <v-layout justify-space-around>
      <v-flex
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>ผู้ใช้งานทั้งหมด</span>
      </v-flex>
    </v-layout>

    <v-row>
      <v-col cols="3">
        <v-text-field
          placeholder="ชื่อ นามสกุล"
          color="#3e7662"
          dense
          outlined
          v-model="searchData.researcherName"
          hide-details
        />
      </v-col>
      <v-col cols="3">
        <v-select
          hide-details
          clearable
          :menu-props="{ bottom: true, offsetY: true }"
          background-color="#3e7662"
          dark
          solo
          flat
          dense
          label="ประเภทผู้ใช้งาน"
          :items="roleList"
          item-text="role"
          item-value="roleID"
          v-model="searchData.typeID"
        />
      </v-col>
      <v-col class="shrink d-flex align-center justify-end">
        <v-btn color="#3e7662" dark @click="search">
          <span class="font-weight-bold">ค้นหา</span>
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="shrink d-flex align-center justify-end">
        <v-btn color="#3e7662" dark @click="onHandleModal('add')">
          <v-icon>add</v-icon>
          <span class="font-weight-bold">เพิ่มผู้ใช้งาน</span>
        </v-btn>
      </v-col>
    </v-row>
    <!-- Table -->
    <v-layout mt-6>
      <v-flex>
        <form-table
          v-if="reload"
          :headers="headers"
          :items="adminList"
          on-view-data
          :EditUser="onHandleModal"
          :VerifyReviewer="verifyReviewer"
        ></form-table>
      </v-flex>
    </v-layout>
    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination
          color="#3E7662"
          :length="paginateUser.last_page"
          :total-visible="9"
          @input="getAdminList"
          v-model="paginateUser.current_page"
        ></v-pagination>
      </v-flex>
    </v-layout>
    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import FormTable from "../../components/table/FormTable";
import { mapState } from "vuex";
import TextfieldForm from "../../components/input/TextfieldForm";

export default {
  components: {
    FormTable,
    Loading,
    TextfieldForm,
  },
  data: () => ({
    reload: true,
    userDialog: false,
    modalTitle: "",
    paginateUser: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    researcherType: [],
    imageUrl: null,
    searchData: {
      researcherName: "",
      typeID: "",
    },
    typeList: [
      { id: 1, name: "สตาฟของ รพ. , พบ." },
      { id: 2, name: "บริษัทยา" },
      { id: 3, name: "พยาบาล" },
      { id: 4, name: "หมอ,แพทย์ประจำบ้าน,นักเรียนแพทย์ทหาร" },
      { id: 5, name: "บุคลากรนอกสังกัด" },
    ],
    roleList: [
      {
        roleID: 1,
        role: "เจ้าหน้าที่",
      },
      {
        roleID: 2,
        role: "เลขานุการ",
      },
      {
        roleID: 3,
        role: "คณะอนุกรรมการฯ",
      },
      {
        roleID: 4,
        role: "ประธาน",
      },
    ],
    isLoading: false,
    fullPage: true,
    headers: [
      {
        text: "ลำดับ",
        value: "number",
        align: "center",
        sortable: false,
        class: "header-data-table",
      },
      { text: "ชื่อ-นามสกุล", value: "name", align: "center", sortable: false },
      // { text: 'ตำแหน่ง', value: 'position', align: "center", sortable: false, },
      // { text: 'หน่วยงาน', value: 'organize', align: "center", sortable: false, },
      // { text: 'ประเภทนักวิจัย', value: 'researcherTypeID', align: "center", sortable: false, },
      {
        text: "ประเภทผู้ใช้งาน",
        value: "user_type",
        align: "center",
        sortable: false,
      },
      { text: "ดูข้อมูล", value: "view", align: "center", sortable: false },
      { text: "แก้ไข", value: "edit", align: "center", sortable: false },
      { text: "อนุมัติ", value: "approve", align: "center", sortable: false },
    ],
    adminList: [],
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    this.getAdminList(1);
    this.getResearcherType();
  },
  methods: {
    // Get Research Type
    getResearcherType() {
      this.isLoading = true;
      this.$store
        .dispatch("User/getResearcherType")
        .then((res) => {
          res.all_researcher_type.forEach((data) => {
            this.researcherType.push({
              id: data.id,
              typeName: data.typeName,
              typeCode: data.typeCode,
            });
          });
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    search() {
      if (this.searchData) {
        this.isLoading = true;
        this.$store
          .dispatch("User/searchAdmin", this.searchData)
          .then((res) => {
            this.adminList = [];
            let j = 1;
            res.data.forEach((data) => {
              this.adminList.push({
                number: j,
                name: data.preNameTh ? data.preNameTh + " " + data.thName : data.thName,
                position: data.position ? data.position : "-",
                organize:
                    (data.affiliation && data.affiliation.affiliation) ?
                        (data.affiliation.affiliation !== 'อื่นๆ' ? data.affiliation.afiiliation : data.otherAffiliation) : "-",
                // user_type: data.isPresident === 1 ? 'ประธาน, ' : ''  +data.isReviewer === 1 ? 'อนุกรรมการ, ' : '' + data.isSecretary === 1 ? 'เลขานุการ, ' : '' +data.isStaff === 1 ? 'เจ้าหน้าที่' : '',
                id: data.id,
                user_type: this.checkUserType(
                  data.isPresident,
                  data.isReviewer,
                  data.isSecretary,
                  data.isStaff
                ),
                linkView: "ViewUser",
                form: "UserManagement",
                deleteUser: data.id,
                isReviewer: data.isReviewer,
                reviewerApprove: data.reviewerApprove,
                // researcherTypeID: data.researcher_type == null? '-': data.researcher_type.typeName,
                onView: 14,
              });
              j++;
            });
            this.paginateUser.current_page = res.current_page;
            this.paginateUser.from = res.from;
            this.paginateUser.last_page = res.last_page;
            this.paginateUser.per_page = res.per_page;
            this.paginateUser.total = res.total;
            this.paginateUser.to = res.to;
            this.isLoading = false;
          })
          .catch((e) => {
            this.isLoading = false;
            Swal.fire({
              title: "ไม่พบนักวิจัย",
              icon: "error",
              position: "center",
              confirmButtonText: "ตกลง",
              confirmButtonColor: "#3E7662",
            }).then(() => {
              this.getAdminList(1);
            });
          });
      } else {
        Swal.fire({
          title: "กรุณากรอกข้อมูลที่ต้องการ ค้นหา",
          icon: "warning",
          position: "center",
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#3E7662",
        });
      }
    },
    getAdminList(page) {
      this.isLoading = true;
      this.$store
        .dispatch("User/getAdminList", page)
        .then((res) => {
          this.adminList = [];
          let i = 1;
          res.data.forEach((data) => {
            this.adminList.push({
              number: i,
              name: data.preNameTh ? data.preNameTh + " " + data.thName : data.thName,
              position: data.position ? data.position : "-",
              organize:
                  (data.affiliation && data.affiliation.affiliation) ?
                      (data.affiliation.affiliation !== 'อื่นๆ' ? data.affiliation.afiiliation : data.otherAffiliation) : "-",
              // user_type: data.isPresident === 1 ? 'ประธาน, ' : ''  +data.isReviewer === 1 ? 'อนุกรรมการ, ' : '' + data.isSecretary === 1 ? 'เลขานุการ, ' : '' +data.isStaff === 1 ? 'เจ้าหน้าที่' : '',
              user_type: this.checkUserType(
                data.isPresident,
                data.isReviewer,
                data.isSecretary,
                data.isStaff
              ),
              id: data.id,
              linkView: "ViewUser",
              form: "UserManagement",
              deleteUser: data.id,
              researcherTypeID:
                data.researcher_type == null
                  ? "-"
                  : data.researcher_type.typeName,
              isReviewer: data.isReviewer,
              reviewerApprove: data.reviewerApprove,
              onView: 14,
            });
            i++;
          });
          this.paginateUser.current_page = res.current_page;
          this.paginateUser.from = res.from;
          this.paginateUser.last_page = res.last_page;
          this.paginateUser.per_page = res.per_page;
          this.paginateUser.total = res.total;
          this.paginateUser.to = res.to;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    },
    onHandleModal(id) {
      this.$router.push({ name: "FormUser", query: { id: id } });
    },
    verifyReviewer(id) {
      Swal.fire({
        title: "คุณต้องการอนุมัติบัญชีอนุกรรมการนี้ ใช่หรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        cancelButtonText: "ไม่ต้องการ",
        confirmButtonText: "ต้องการ",
      }).then((result) => {
        this.isLoading = true;
        if (result.value) {
          this.$store
            .dispatch("User/verifyReviewer", id)
            .then((res) => {
              this.isLoading = false;
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.getAdminList();
              });
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // }).then(() => {
              //     this.isLoading = false;
              // })
            });
        }
        this.isLoading = false;
      });
    },
    checkUserType(u1, u2, u3, u4) {
      console.log(u1, u2, u3, u4);
      var user1 = "";
      var user2 = "";
      var user3 = "";
      var user4 = "";
      var full = "";
      if (u1 == 0 && u2 == 0 && u3 == 0 && u4 == 0) {
        return "-";
      } else {
        if (u1 == 1) {
          user1 = "ประธาน,";
        }
        if (u2 == 1) {
          user2 = " อนุกรรมการ,";
        }
        if (u3 == 1) {
          user3 = " เลขานุการ,";
        }
        if (u4 == 1) {
          user4 = " เจ้าหน้าที่,";
        }
        full = user1 + user2 + user3 + user4;
        return full.substring(0, full.length - 1);
      }
    },
  },
};
</script>

<style lang="scss">
.header-data-table {
  font-size: 20px;
}
</style>
